import React from "react";
import Background from "../../assets/images/dedeman1.jpeg";
import { Link } from "react-router-dom";

const FirstPage = () => {
  return (
    <div className="h-screen relative overflow-hidden w-full">
      <img
        src={Background}
        alt="img"
        className="object-center w-full h-full absolute inset-0 z-0"
      />
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center">
        <Link
          to="/category"
          className="text-pink-900 bg-slate-100 rounded-full px-8 py-4 text-2xl text-center relative z-10"
        >
          Menü
        </Link>
      </div>
    </div>
  );
};

export default FirstPage;
